// "Production" enabled environment

export const environment = {
	production: false,
	hmr: false,
	appConfig: 'appconfig.staging.json',
};
